/**
 *
 * Team: TA37 - The Coders' Assembly
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTAButton.css';

const CTAButton = ({
  label = 'Check My Relapse Risk',
  onClick,
  to,
  ariaLabel,
  disabled = false,
  className = '',
  type = 'button',          // NEW: allow overriding button type
}) => {
  const navigate = useNavigate();

  const handleClick = (event) => {
    if (disabled) return;

    if (to) {
      event.preventDefault();  // prevent form submit on navigation buttons
      navigate(to);
    } else if (onClick) {
      onClick(event);          // pass event through
    }
  };

  return (
    <button
      className={`cta-button ${className}`}
      onClick={handleClick}
      aria-label={ariaLabel || label}
      disabled={disabled}
      type={type}
    >
      {label}
    </button>
  );
};

export default CTAButton;